import axios from "axios"

import i18n from "../i18n/config"

export const bffApi = axios.create({
  baseURL: `/bff/skipass`,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
})

bffApi.interceptors.request.use((config) => {
  config.headers["Accept-Language"] = i18n.language
  return config
})

export const publicApi = axios.create({
  baseURL: `/_publicapi`,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
})
